import { useQuery } from '@tanstack/react-query'
import { useSearchParams } from 'react-router-dom'
import { TAlertRuleDevice, TDevice } from 'shared/types'
import { api, getDevice } from '..'

export const getDevicesByAlertRuleList = (
  alertRuleId: string,
  params?: Record<string, string>,
) =>
  api
    .get<TAlertRuleDevice[]>(`/v1/alert-rules/${alertRuleId}/devices`, params)
    .then(({ data }) => data)

export const getDevicesByAlertRule = async (
  alertRuleId: string,
  params?: Record<string, string>,
) => {
  const list = await getDevicesByAlertRuleList(alertRuleId, params)

  const promises = list.map(device => getDevice(device.deviceId))
  const data = await Promise.all(promises)

  return data as TDevice[]
}

export const getDevicesByAlertRuleQuery = (
  alertRuleId: string,
  params?: Record<string, string>,
) => ({
  queryKey: ['alertRule', alertRuleId, 'devices', params],
  queryFn: () => getDevicesByAlertRule(alertRuleId, params),
})

export const useGetDevicesByAlertRule = (alertRuleId?: string) => {
  const [urlParams] = useSearchParams()
  const params = Object.fromEntries(urlParams.entries())

  if (!alertRuleId) throw new Error('Missing alertRuleId')

  const query = getDevicesByAlertRuleQuery(alertRuleId, params)

  return useQuery({
    ...query,
    keepPreviousData: true,
  })
}
